module.exports = __webpack_public_path__ + "static/teleco_11-40a77b2d880550a1ec9d8c587d8c5105.jpg";